/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ConfidentialInputs */

const de__field_confidential = /** @type {(inputs: _Field_ConfidentialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einverständnis Vertraulich`)
};

/**

* @param {_Field_ConfidentialInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_confidential = /** @type {((inputs?: _Field_ConfidentialInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ConfidentialInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_confidential(inputs)
});